import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const borderless = css`
  border: none;
  padding: 0;

  legend {
    padding: 0;
  }
`;

export const checkboxWithLabel = css`
  ${/* Ribbons Checkbox uses flex but margin to centrally align ¯\_(ツ)_/¯ */ ''}
  margin: 0;
  align-items: center;
`;

export const fieldFeedbackContainer = css`
  display: flex;
  margin-top: ${pxToRem(spacing.xs)};
`;
